import { useState } from "react";

type Props = {
    date: { from: string; to: string };
    setDate: React.Dispatch<any>;
};

const getToday = () => new Date().toISOString().split("T")[0];

const getYesterday = () => {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return d.toISOString().split("T")[0];
};

const getMonthRange = (type: "this" | "last") => {
    const now = new Date();

    if (type === "this") {
        const start = new Date(now.getFullYear(), now.getMonth(), 1);
        return {
            from: start.toISOString().split("T")[0],
            to: getToday(),
        };
    }

    const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const end = new Date(now.getFullYear(), now.getMonth(), 0);

    return {
        from: start.toISOString().split("T")[0],
        to: end.toISOString().split("T")[0],
    };
};

const DashboardHeader = ({ date, setDate }: Props) => {
    const [filter, setFilter] = useState("today");

    const handleFilterChange = (value: string) => {
        setFilter(value);

        switch (value) {
            case "today":
                const today = getToday();
                setDate({ from: today, to: today });
                break;

            case "yesterday":
                const y = getYesterday();
                setDate({ from: y, to: y });
                break;

            case "this_month":
                setDate(getMonthRange("this"));
                break;

            case "last_month":
                setDate(getMonthRange("last"));
                break;

            case "custom":
                // don't change date, user will pick
                break;
        }
    };

    return (
        <div className="flex flex-wrap justify-end items-center gap-3 bg-white p-4 rounded-xl shadow-sm">

            {/* Dropdown */}
            <select
                value={filter}
                onChange={(e) => handleFilterChange(e.target.value)}
                className="border rounded px-3 py-2 text-sm"
            >
                <option value="today">Today</option>
                <option value="yesterday">Yesterday</option>
                <option value="this_month">This Month</option>
                <option value="last_month">Last Month</option>
                <option value="custom">Custom Range</option>
            </select>

            {/* Custom Date Inputs */}
            {filter === "custom" && (
                <>
                    <input
                        type="date"
                        value={date.from}
                        onChange={(e) =>
                            setDate((p: any) => ({ ...p, from: e.target.value }))
                        }
                        className="border px-2 py-1 rounded"
                    />
                    <input
                        type="date"
                        value={date.to}
                        onChange={(e) =>
                            setDate((p: any) => ({ ...p, to: e.target.value }))
                        }
                        className="border px-2 py-1 rounded"
                    />
                </>
            )}
        </div>
    );
};

export default DashboardHeader;